import { combineReducers } from 'redux';
import metrics from './metrics';
import brandAdoption from './brandAdoption';

export default combineReducers({
  metrics,
  brandAdoption
});
